// extracted by mini-css-extract-plugin
module.exports = {"sectiontwo":"Aboutsectiontwo_sectiontwo__1ix5L"};